/**
 * Core components.
 *
 * @module postprocessing/core
 */

export { EffectComposer } from "./EffectComposer.js";



// WEBPACK FOOTER //
// ./src/lib/vendor/postprocessing/core/index.js